import React from 'react';
import { ButtonDropdown } from 'ui-toolkit';
import { eMatchedQueryValue } from '../../types/accounting/eMatchedQueryValue';
import { IDropdownItemProps } from 'ui-toolkit/components/Dropdown/DropdownItem';

export interface IIsMatchedFilterProps {
  matched?: eMatchedQueryValue;
  onChange: (matched: eMatchedQueryValue | undefined) => void;
  items: eMatchedQueryValue[];
}

export const IsMatchedFilter: React.FC<IIsMatchedFilterProps> = ({ matched, onChange, items }) => {
  const itemTextMappings = {
    [eMatchedQueryValue.UNMATCHED]: 'Unmatched',
    [eMatchedQueryValue.MATCHED]: 'Matched',
    [eMatchedQueryValue.MISMATCHED]: 'Mismatched',
    [eMatchedQueryValue.ALL]: 'All transactions',
  };

  const itemProps: IDropdownItemProps[] = [];
  items.forEach((it) => itemProps.push({ children: itemTextMappings[it], onClick: () => onChange(it) }));

  return (
    <ButtonDropdown intent={'ghost'} isInline items={itemProps}>
      {matched && itemTextMappings[matched] ? itemTextMappings[matched] : 'undefined'}
    </ButtonDropdown>
  );
};
